import {
  SESSION_ENDED_EVENT,
  clearClientSessionState,
} from "utils/sessionCleanup"

export { SESSION_ENDED_EVENT, clearAuthAndTenantStorage } from "utils/sessionCleanup"

const dispatchSessionEndActions = () => {
  // Lazy require avoids circular imports through store → reducers → api_helper.
  const store = require("store").default
  const { clearLoginSession } = require("store/reducers/authReducer")
  const { resetAuth } = require("store/slices/authSlice")
  const { clearTenant } = require("store/slices/tenantSlice")

  if (store?.dispatch) {
    store.dispatch(clearLoginSession())
    store.dispatch(resetAuth())
    store.dispatch(clearTenant())
  }
}

/**
 * Fully tear down the client session: storage, DOM branding, Redux, and context listeners.
 *
 * @param {{ dispatchRedux?: boolean, clearDom?: boolean, notify?: boolean }} [options]
 */
export const endSession = ({
  dispatchRedux = true,
  clearDom = true,
  notify = true,
} = {}) => {
  clearClientSessionState({ clearDom, notify })

  if (dispatchRedux) {
    dispatchSessionEndActions()
  }
}

export { redirectToLoginAfterSessionEnd } from "utils/sessionCleanup"
